import styled from 'styled-components'

export const Container = styled.label<{ isActive: boolean }>`
  display: flex;
  cursor: text;
  align-items: center;
  background-color: #f0f0f0;
  border-radius: 120px;
  border: 1px solid ${({ theme }) => theme.colors.warmGray.warm400};
  font-size: 16px;
  padding: 12px;
  height: 44px;
  width: 100%;
  box-shadow: ${({ isActive }) => (isActive ? '0 0 5px rgba(0,0,0,0.2)' : 'none')};
  transition: 0.3s linear;

  @media (min-width: 992px) {
    width: 232px;
  }
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding: 0 16px;
`

export const Icon = styled.img`
  height: 1em;
`
export const SearchIcon = styled.span`
  ${Icon};
  display: flex;
  margin-right: 8px;
  color: ${({ theme }) => theme.colors.text.secondary};
`

export const ClearIcon = styled.button`
  ${Icon};
  display: flex;
  margin: 0;
  border: none;
  color: ${({ theme }) => theme.colors.text.secondary};
  cursor: pointer;
  padding: 12px;

  @media (min-width: 992px) {
    padding: 6px 0;
  }
`

export const CloseButton = styled.button<{ isActive: boolean }>`
  ${Icon};
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: ${({ isActive }) => (isActive ? '12px' : '0')};
  border: none;
  color: ${({ theme }) => theme.colors.brand.white};
  cursor: pointer;
  width: ${({ isActive }) => (isActive ? '60px' : '0')};
  height: 36px;
  transition: 0.3s linear;
  background-color: transparent;

  img {
    display: ${({ isActive }) => (isActive ? 'block' : 'none')};
  }
`

export const SearchInput = styled.input`
  border: none;
  outline: none;
  background: transparent;
  font-size: 1em;
  font-family: Roboto, sans-serif;
  width: 100%;
`
